import React, { useContext } from "react";

import { faPause, faPlay } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MeetingPhaseContext, { type CopilotStatus } from "~/stream/MeetingPhaseContext";

import { ControlGroupButtonTooltip, ControlGroupIconButton } from "./SharedComponents";

import styles from "./InMeetingControls.module.css";

type CopilotStatusType = Extract<CopilotStatus["type"], "recording" | "paused">;

export default function PauseRecordingButton({ copilotStatus }: { copilotStatus: CopilotStatusType }) {
	const { pauseRecording, resumeRecording } = useContext(MeetingPhaseContext);

	switch (copilotStatus) {
		case "recording": {
			return (
				<ControlGroupButtonTooltip content="Pause">
					<ControlGroupIconButton onClick={pauseRecording}>
						<FontAwesomeIcon icon={faPause} className={styles.squareIcon} />
					</ControlGroupIconButton>
				</ControlGroupButtonTooltip>
			);
		}
		case "paused": {
			return (
				<ControlGroupButtonTooltip content="Resume">
					<ControlGroupIconButton onClick={resumeRecording}>
						<FontAwesomeIcon icon={faPlay} className={styles.squareIcon} />
					</ControlGroupIconButton>
				</ControlGroupButtonTooltip>
			);
		}
	}
}
